'use client';

import { useTranslations } from 'next-intl';
import type { CommentsPage } from '@/lib/api/comments';
import { useOrderFormStore } from '@/lib/store/order-form-store';
import { Empty } from '../Empty';
import { CommentForm } from './CommentForm';
import { CommentItem } from './CommentItem';
import { CommentsProvider } from './CommentsContext';
import { CommentsList } from './CommentsList';

interface EventCommentsProps {
  /** Explicit id so the list renders on the server, where the store is empty. */
  eventId?: string;
  /** First page from SSR: rendered into the HTML and seeds the query cache. */
  initialPage?: CommentsPage;
}

export const EventComments = ({ eventId: eventIdProp, initialPage }: EventCommentsProps) => {
  const t = useTranslations('eventComments');
  const event = useOrderFormStore.use.event();
  const eventId = eventIdProp ?? event?.id ?? null;

  if (!eventId) {
    return null;
  }

  return (
    <CommentsProvider source={{ kind: 'event', eventId }}>
      <div className="flex flex-col gap-4">
        <CommentForm />
        <CommentsList
          Item={CommentItem}
          initialPage={initialPage}
          errorFallback={<Empty title={t('somethingWentWrong')} desc={t('failedToLoadComments')} />}
        />
      </div>
    </CommentsProvider>
  );
};
